import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientScheduleApplication のスタイル
 */
export const hotlineClientScheduleApplicationStyle = tv({
    slots: {
        base: [
            'flex flex-col items-center',
            'bg-blue-gray-75',
            'p-16',
            'rounded-md',
        ],
        button: ['mx-auto mt-24'],
        cancelDescriptionText: ['mt-8'],
        cancelWrap: [
            'flex flex-col items-center',
            'w-full',
            'border-t border-x-0 border-b-0 border-solid border-gray-300',
            'py-24 px-16',
            'mt-24',
        ],
        chargePaymentDescription: ['mt-24'],
        fieldWrap: ['justify-center', 'w-full', 'mt-16'],
        priceText: [
            'text-center',
            'w-full',
            'p-16',
            'mt-16',
            'bg-white',
            'rounded-md',
        ],
    },
});
